import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-06-17
	search(params) {
		return axios.get('/inventory-force-outs', params)
	},

	// 2021-06-17
	ignore(id) {
		return axios.put('/inventory-force-outs/' + id + '/ignore');
	},
	// 2021-06-17
	agree(id, params) {
		return axios.put('/inventory-force-outs/' + id + '/agree', params);
	},
	// 2021-06-17
	unDealCount() {
		return axios.get('/inventory-force-outs/un-deal-count');
	},

}